<template>
  <div id="sideSchedule">
    <ul class="scroll-box" ref="anchorBox">
      <li
        v-for="(arrange, key) in arrangeList"
        :key="key"
        :class="{ anchor: arrange.status === 3 }"
        @click="showTeams(arrange)"
      >
        <div class="header">
          <div class="title">
            <UiLabel shadow-color="rgba(255,255,255,0.8)" text-color="#C64F52">{{ arrange.title }}</UiLabel>
          </div>
          <UiLabel class="time" shadow-color="#FFFFFF" text-color="#C64F52">{{ arrange.day }} {{ arrange.time }}</UiLabel>
        </div>
        <ul class="teams">
          <li
            v-for="i in 7"
            :key="i"
            :name="i"
            :style="{
            'background-image': `url(${
              arrange.teams[i - 1] ? arrange.teams[i - 1].avatar||defaultAvatar : defaultAvatar
            })`,
          }"
          ></li>
          <li name="8" class="more">
            <div>更多队伍</div>
          </li>
        </ul>
        <div class="bottom">
          <div class="status" :class="{ active: arrange.status === 2 }">
            <UiLabel>{{ getStatus(arrange.status) }}</UiLabel>
          </div>

          <UiButton
            class="details"
            :class="{ hasPoints: arrange.status !== 1 }"
            @click="(e) => showScores(e,
            arrange,
            `${arrange.day ? arrange.day : ''} ${
              arrange.week ? arrange.week : ''
            } ${arrange.title ? arrange.title : ''}`
          )"
          >
            <UiLabel>积分详情</UiLabel>
            <i></i>
          </UiButton>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, watch, nextTick, useTemplateRef } from 'vue'
import UiButton from "@/components/ui-button";
import UiLabel from "@/components/ui-label";

const props = defineProps({
  openScore: {
    type: Function,
    default: () => {},
  },
  openTeams: {
    type: Function,
    default: () => {},
  },
  arrangeList: {
    type: Array,
    default: () => [],
  },
  handleAnchor: {
    type: Function,
    default: () => {},
  },
});

const anchorBox = useTemplateRef('anchorBox')


// arrangeList: [],
const defaultAvatar = ref("https://website.xdcdn.net/poster/sausage/match/zhanduilogo/z51MQgVN.png");

watch(
  () => props.arrangeList,
  () => {
    nextTick(() => {
      let $anchorBox = anchorBox.value,
        $anchors = document.getElementsByClassName("anchor");
      if ($anchors && $anchors.length !== 0) {
        let $end = $anchors[$anchors.length - 1];
        let offsetTop = $end.offsetTop - $anchorBox.offsetTop;
        props.handleAnchor(offsetTop);
      }
    });
  }
);

function getStatus(value) {
  let subStatus = "";
  switch (Number(value)) {
    case 1:
      subStatus = "未开始";
      break;
    case 2:
      subStatus = "进行中";
      break;
    case 3:
      subStatus = "已结束";
      break;
  }

  return subStatus;
}
function showTeams(arrange) {
  // 参赛战队
  props.openTeams(arrange.teams ? arrange.teams : []);

  // 埋点
  if(typeof tapdb === 'undefined') return;
  tapdb.trackEvent('查看队伍 - 直播', {
    '#schedule_id': arrange.title,
  });
}
function showScores(e, arrange, title) {
  e.stopPropagation();

  // 积分详情
  props.openScore(arrange.scheduleCode, title);

  // 埋点
  if(typeof tapdb === 'undefined') return;
  tapdb.trackEvent('查看对局 - 直播', {
    '#schedule_id': arrange.title,
    "#match_id": '总积分'
  });
}
</script>

<style lang="scss" scoped>
#sideSchedule {
  width: 100%;
  height: 100%;
  @include r(padding, 8, 8, 0);
  box-sizing: border-box;

  .scroll-box {
    overflow: hidden scroll;
    width: 100%;
    height: 100%;
    @include scrollBarIE();
  }

  .scroll-box > li {
		position: relative;
		isolation: isolate;
		box-sizing: border-box;
		@include r(padding, 12, 8);
    @include r(width, 292);
    @include r(height, 246);
		@include r(margin-bottom, 10);
		@include r_shadow(0, 4, 4, rgba(#000, 0.2));

		// 背景 + 边框独立层, 不影响布局尺寸/padding 计算
		&::before {
			content: '';
			position: absolute;
			inset: 0;
			z-index: -1;
			background: linear-gradient(180deg, #FFDFDF, #FFFFFF);
			border-style: solid;
			border-color: #FFFFFF;
			@include r(border-width, 2);
			box-sizing: border-box;
		}

		.header {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
      @include r(height, 20);
			@include r(font-size, 16);
			@include r(margin-bottom, 14);

			.title {
				position: relative;
				display: flex;
				align-items: center;

				:deep(.label-shadow),
				:deep(.label-text) {
					@include r(max-width, 140);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}
		}

		.teams {
			display: flex;
			justify-content: space-between;
      align-content: space-between;
			flex-wrap: wrap;
      @include r(width, 276);
      @include r(height, 134);

			li {
				box-sizing: border-box;
				@include r(width, 62);
				@include r(height, 62);
				background-color: #fff;
				border-style: solid;
				border-color: #FFD3D3;
				@include r(border-width, 2);
				border-radius: 50%;
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;

				&.more {
          display: flex;
          justify-content: center;
          align-items: center;
          div {
            width: 50%;
            text-align: center;
            color: #C64F52;
            font-weight: bold;
            white-space: pre-line;
            @include r(font-size, 14);
            @include r(line-height, 16);
          }
        }
			}
		}

		.bottom {
			display: flex;
			justify-content: space-between;
			align-items: center;
      width: 100%;
      @include r(height, 44);
      @include r(margin-top, 11);
			@include r(font-size, 20);
			.status {
        @include r(padding-inline, 10);
				// 默认: 未开始(1) / 已结束(3)
        --label-shadow-color: #{rgba(#000, 0.05)};
				--label-text-color: #410201;
				// 进行中(2)
				&.active {
					--label-shadow-color: #FFFFFF;
					--label-text-color: #C64F52;
				}
			}
			.details {
				@include r(width, 126);
				@include r(height, 44);
				display: none;
				// 内部 UiLabel 描边 / 内容色 (改这两行调 label 颜色)
				--label-shadow-color: #{rgba(#000, 0.4)};
				--label-text-color: #fff;

        &::before {
          content: '';
          position: absolute;
          z-index: -1;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: #B6050D;
          border: solid #e90e17;
          box-sizing: border-box;
          @include r(border-width, 2);
        }

				i {
					display: inline-block;
					@include r(width, 13);
					@include r(height, 15);
					background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/Q3uH7gmm.png);
					background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
					@include r(margin-left, 6);
				}
				&.hasPoints {
					display: flex;
				}
			}
		}
	}
}
</style>
